import { useEffect, useState, useRef } from 'react';

type ScreenSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export function useScreenSize(): ScreenSize {
  const [screenSize, setScreenSize] = useState<ScreenSize>();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 767) {
        setScreenSize('sm');
      } else if (width >= 768 && width <= 1023) {
        setScreenSize('md');
      } else if (width >= 1024 && width <= 1199) {
        setScreenSize('lg');
      } else if (width >= 1200 && width <= 1439) {
        setScreenSize('xl');
      } else if (width >= 1440) {
        setScreenSize('2xl');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // 初始化时获取初始屏幕大小

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
}

export const useSyncState = (state) => {
  const cbRef: { current } = useRef();
  const [data, setData] = useState(state);

  useEffect(() => {
    cbRef.current && cbRef.current(data);
  }, [data]);

  return [
    data,
    (val, callback) => {
      cbRef.current = callback;
      setData(val);
    },
  ];
};
